module.exports = __webpack_public_path__ + "static/media/warningIcon.a0130a43.svg";